import Markdown, { Components } from 'react-markdown'
import remarkGfm from 'remark-gfm'
import rehypeRaw from 'rehype-raw'
import styles from './MarkdownRenderer.module.less'
import cls from 'classnames'
import { Skeleton } from 'antd'
import { useInViewport } from 'ahooks'
import { useEffect, useRef, useState } from 'react'

interface Props {
  markdownText: string
  loading?: boolean
  components?: Components | null | undefined
  needAnimation?: boolean
  animationEnd?: () => void
  className?: string
  style?: React.CSSProperties
}
function MarkdownRenderer(props: Props) {
  const markdownText = props.markdownText || ''
  const dom = useRef<HTMLDivElement>(null)
  const [doAnimation, setDoAnimation] = useState(false)
  /** 这里做一下兼容，将不符合格式的 \n 转化为符合格式的 \n */
  const renderText = markdownText.replace(/\n/g, '  \n')
  // const renderText = props.markdownText

  useInViewport(dom.current, {
    threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
    callback: (entry) => {
      const { intersectionRatio } = entry
      if (intersectionRatio >= 0.2 && props.needAnimation) {
        setDoAnimation(true)
      }
    },
  })

  useEffect(() => {
    if (doAnimation) {
      props.animationEnd?.()
    }
  }, [doAnimation])

  return props.loading ? (
    <Skeleton active />
  ) : (
    <div
      className={cls(styles.markdownRenderer, props.className, styles.markdownBody, {
        [styles.needAnimation]: props.needAnimation,
        [styles.letterSpacingAnimation]: doAnimation,
      })}
      ref={dom}
      style={props.style}
    >
      <Markdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw]}
        components={props.components}
      >
        {renderText}
      </Markdown>
    </div>
  )
}

export default MarkdownRenderer
